module.exports = __webpack_public_path__ + "static/learning-200fd4bd0ab52b5b59e3d0bfb03690b4.svg";